import type { Book } from './types'

const objectKey = (prefix: 'pdf' | 'epub' | 'capa', id: number) =>
  `${prefix}${String(id).padStart(2, '0')}`

export const COLLECTION_NAME = 'Coleção: Gestão, Tecnologia e Competitividade'

export const COLLECTION_DESCRIPTION =
  'Produção editorial e disponibilização de conteúdo digital destinada à formação e atualização de empresários, gestores, comerciários e profissionais dos setores de comércio e serviços.'

export const CATALOGUE: readonly Book[] = [
  {
    id: 1,
    title: 'Inteligência Artificial Aplicada à Gestão e ao Trabalho',
    description:
      'Seleção de tarefas, dados, instruções, aplicações, avaliação e governança de soluções de inteligência artificial.',
    coverKey: objectKey('capa', 1),
    files: { pdf: objectKey('pdf', 1), epub: objectKey('epub', 1) },
  },
  {
    id: 2,
    title: 'Comércio Digital, Vendas e o Novo Consumidor',
    description:
      'Comércio eletrônico, marketplaces, social commerce, omnichannel, CRM, experiência do cliente, marketing, indicadores e jornada do consumidor.',
    coverKey: objectKey('capa', 2),
    files: { pdf: objectKey('pdf', 2), epub: objectKey('epub', 2) },
  },
  {
    id: 3,
    title: 'Finanças, Crédito e Gestão Financeira para Empresas e Gestores',
    description:
      'Fluxo de caixa, capital de giro, custos, preços, margens, orçamento, crédito, pagamentos digitais, indicadores e investimentos.',
    coverKey: objectKey('capa', 3),
    files: { pdf: objectKey('pdf', 3), epub: objectKey('epub', 3) },
  },
  {
    id: 4,
    title: 'Cibersegurança, Proteção de Dados e Prevenção a Fraudes',
    description:
      'Ativos, acessos, engenharia social, phishing, ransomware, fraudes, credenciais, dispositivos, LGPD, backups, incidentes e continuidade.',
    coverKey: objectKey('capa', 4),
    files: { pdf: objectKey('pdf', 4), epub: objectKey('epub', 4) },
  },
  {
    id: 5,
    title: 'Gestão de Pessoas, Liderança e Alta Performance',
    description:
      'Responsabilidades, seleção, delegação, comunicação, aprendizagem, feedback, conflitos, desempenho, metas, bem-estar e mudança organizacional.',
    coverKey: objectKey('capa', 5),
    files: { pdf: objectKey('pdf', 5), epub: objectKey('epub', 5) },
  },
  {
    id: 6,
    title: 'Gestão por Processos, Indicadores e Tomada de Decisão',
    description:
      'Arquitetura e mapeamento de processos, capacidade, padrões, produtividade, qualidade, métricas, KPIs, dashboards, riscos, PDCA, 5W2H e priorização.',
    coverKey: objectKey('capa', 6),
    files: { pdf: objectKey('pdf', 6), epub: objectKey('epub', 6) },
  },
]

export const getBook = (id: number) => CATALOGUE.find((book) => book.id === id)
